import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./PointGift.module.scss";
import Header from "../../molecules/header/Header";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import PointHeader from "../../organism/point-header/PointHeader";
import TopHeader from "../../organism/top-header/TopHeader";
import TopSummary from "../../organism/top-summary/TopSummary";
import GiftCard from "../../organism/gift-card/GiftCard";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { fetchGift } from "../../api/GiftApi";
import rabbitWinkNormal from "../../static/images/rabbit-wink-normal.png";
import mokomokoGray from "../../static/images/mokomoko-gray.png";
import { fetchUser } from "../../api/UsersApi";

type PointGiftLocationState = {
  ownerLabel?: string;
  pointOwnerId?: number;
  availableGiftPoint?: number;
};

const PointGift = () => {
  const giftApi = fetchGift();
  const userApi = fetchUser();
  const navigate = useNavigate();
  const location = useLocation();
  const pointGiftState = location.state as PointGiftLocationState | null;
  const currentPoint = userApi.state?.data?.[0]?.currentPoint ?? 0;
  const ownerLabel = pointGiftState?.ownerLabel ?? "あなた";
  const pointOwnerId = pointGiftState?.pointOwnerId;
  const availableGiftPoint = pointGiftState?.availableGiftPoint ?? currentPoint;

  useEffect(() => {
    userApi.fetch();
    giftApi.fetch({ giftType: "all" });
  }, []);

  const gifts = giftApi.state?.data?.[0]?.giftList ?? [];

  return (
    <section className={classes.container}>
      <Header />
      <TopHeader currentMenuUrl="/point" />
      <PointHeader aquiredPoint={currentPoint} />
      <div className={classes.summaryArea}>
        <TopSummary
          leftLogo={rabbitWinkNormal}
          mainTitle="ポイントをごほうびに交換"
          rightLogo={mokomokoGray}
        />
      </div>
      <div className={classes.exchangeSummaryBox}>
        <div className={classes.ownerLabel}>{ownerLabel}</div>
        <div className={classes.exchangeLabel}>ごほうびに交換できるポイント</div>
        <div className={classes.exchangeAmount}>
          <span>{availableGiftPoint.toLocaleString("ja-JP")}</span>
          <span>pt</span>
        </div>
      </div>
      <div className={classes.downArrow}>⌄</div>
      {gifts.map((gift) => (
        <GiftCard
          key={gift.giftId}
          image={gift.giftImage}
          title={gift.giftName}
          point={gift.requiredPoint}
          effectiveFrom={gift.effectiveFrom}
          effectiveTo={gift.effectiveTo}
          onClick={() =>
            navigate(`/point-exchange/${gift.giftId}`, {
              state: {
                ownerLabel,
                pointOwnerId,
                availableGiftPoint,
              },
            })
          }
        />
      ))}
      <div className={classes.backButton}>
        <SimpleButton
          label="戻る"
          width="60%"
          color="gray"
          isRadius={true}
          onClick={() => navigate("/point")}
        />
      </div>
      <BreadCrumb
        data={[
          { displayName: "みらいいコンシェル" },
          { displayName: "ポイント", url: "/point" },
          { displayName: "ごほうび" },
        ]}
      />
    </section>
  );
};

export default PointGift;
